import {
  FundingBadgeListData,
  ProductBadgeListData,
  ProductBadgeListOption,
} from '@services/MarppleShop/renderApp/components/cells/ProductBadgeList/ProductBadgeList.ts';
import { ProductBadgeBase } from '../../ProductBadge/ProductBadgeBase';
import { ProductBadgeType } from '@services/MarppleShop/features/ProductBadge/type';

export enum ContextPageType {
  LIST = 'LIST',
  DETAIL = 'DETAIL',
}

export enum ProductBadgeVariant {
  DEFAULT_BADGE = 'DEFAULT_BADGE',
  FUNDING_BADGE = 'FUNDING_BADGE',
}

export interface PageContext {
  pageType: ContextPageType;
}

/**
 * 뱃지 정의 인터페이스
 */
interface BadgeDefinition<T> {
  type: ProductBadgeType;

  /**
   * 정렬: priority ASC
   * 같은 우선 순위를 가지고 있다면 해당 우선순위에서 뱃지가 배타적으로 하나만 보여집니다.
   */
  priority: number;

  /**
   * 해당 보일지 말지 정하는 함수입니다.
   */
  shouldShow: (data: T, pageContext: PageContext) => boolean;

  createBadge: (data: T, option: ProductBadgeListOption, pageContext: PageContext) => ProductBadgeBase;
}

export type MpsV1BadgeDefinition = BadgeDefinition<ProductBadgeListData>;
export type MpsV2BadgeDefinition = BadgeDefinition<ProductBadgeListData>;
export type FundingBadgeDefinition = BadgeDefinition<FundingBadgeListData>;

/**
 * 뱃지 전략 인터페이스
 */
export interface IProductBadgeStrategy<Def> {
  getBadgeDefinitions(): Def[];
}
